export const environment = {
    production: false,
    url_api: "https://middleware-dot-text-inspector-prod.uc.r.appspot.com",
    text_v1: "https://textinspector.demosandbox.net",
    text_wp: "https://stg-textinspector-textinspstg.kinsta.cloud/",
    version: "2.1.0-stg"
  };
